/*
 * Ported verbatim from the legacy app's scripts/app/components/athletes.js.
 */

(function ($) {

    $(function () {
        var body = $('body');
        var html = $('html');
        var athletesSearchResultContainer = $('#js-athletes-search-results');
        var baseUrl = window.location.href.split('?')[0];
        if (baseUrl.substr(-1) !== '/') {
            baseUrl += baseUrl + '/';
        }

        //
        // SEARCH PAGE
        //
        body.on('click', '.athletes-search-submit',
            function () {
                var searchQuery = $('.athletes-search-text').val();
                var searchUrl = $(this).attr('data-url');
                if (searchQuery) {
                    body.addClass('searching');
                }
            });
        
        body.on('keypress', '.athletes-search-text', function (e) {
            if ($('.athletes-search-text').text().length > 2) {
                $('.athletes-search-submit').trigger('click');
                return false;
            }
            return true;
        });


        function replaceChars(str) {
            if (str) {
                return str.toLowerCase()
                    .replace(/æ/g, 'ae')
                    .replace(/ø/g, 'oe')
                    .replace(/å/g, 'aa')
                    .replace(/\//g, '-')
                    .replace(/\./g, '')
                    .replace(/ /g, '-')
                    .replace(/'/g, '')
                    .replace(/"/g, '')
                    .replace(/&/g, '')
                    .replace(/,/g, '');
            }
            return str;
        }
    });

})(window.jQuery);
